var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.$filters.formatDate(_vm.value))),_c('br'),_vm._v(" "+_vm._s(_vm.$filters.formatTime(_vm.value))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }